var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"noticeBox",staticClass:"ng-notice"},[_c('div',{ref:"noticeContent",class:['ng-notice-content', _vm.animation ? 'notice-animation' : ''],style:(_vm.style)},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }